var map = {
	"./p00.png": 7981,
	"./p01.png": 5890,
	"./p02.png": 7943,
	"./p03.png": 145,
	"./p04.png": 1824,
	"./p05.png": 5968,
	"./p06.png": 4039,
	"./p07.png": 9238,
	"./p08.png": 1602,
	"./p09.png": 9688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4253;